<template>
    <div>
        <Nav bgColor="#FFFFFF" />
        <div class="d-flex align-items-center justify-content-center pt-3">
            <div class="d-flex align-items-center text-start text-white px-5">
                <span class="text-uppercase text-black  display-header home-text mx-2 text-center">Contact</span>
            </div>

        </div>

        <div class="bg-dark w-100 mb-3 mt-5" style="height: 2px;"></div>
        <div class="container-fluid open-sans">
            <div class="row py-5">
                <div class="col-12 col-md-6 col-lg-4 offset-lg-1">
                    <div class="display-2 text-uppercase oswald-bold pb-4"> Get in Touch!</div>
                    <div> For general questions plase email</div>
                    <div class="pb-4"><a href="mailto:info@atlasimprov.com"
                            class="contact-link">info@atlasimprov.com</a></div>
                    <div> For questions about classes, plase email</div>
                    <div><a href="mailto:edu@atlasimprov.com" class="contact-link py-3">edu@atlasimprov.com</a></div>
                    <div class="display-2 text-uppercase oswald-bold pt-5 pb-4"> Location & parking</div>
                    <div class="pb-3"> We are located at:</div>
                    <div><a href="https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703"
                            class="location-link pb-4 oswald-bold fs-5 " target="_blank" rel="noopener">609 E. Washington Ave.<br>Madison, WI
                            53703</a></div>
                    <div class="pb-4 pt-3"> Parking is available in the MGE good neighbor lots at 640 E. Main Street and 1600 Railroad
                        Steet. Parking can also be found in the lot at 665 E. Washington Ave., adjacent to the Brass
                        Ring. These Lots are marked in green on the map. There is also some steet parking on nearby
                        Blount and Main Streets.
                    </div>

                </div>
                <div class="col-12 col-md-6 col-lg-5 offset-lg-1">

                    <img :src="`${$API_ASSETS}9575146c-0de7-462b-bcde-040e373996b1.png`" class="img-fluid w-100" />
                    <div class="pt-2 text-start">
                      <a href="https://www.google.com/maps?q=609+E+Washington+Ave+Madison,+WI+53703" class="contact-link text-decoration-underline" target="_blank" rel="noopener">Click here for Directions</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="container-fluid position-relative pt-2 site-black-bg">
            <!-- Background Image -->
            <div class="position-relative">
                <!-- Overlayed Text Container -->
                <div class="position-absolute w-100 text-overlay" style="top: 20%; left: 0; padding-left: 10%;">
                    <div class="col-lg-4 text-white text-start" v-if="press">
                        <div class="press-grid">
                          <div class="col-span-2">
                            <div class="text-uppercase display-4 oswald-bold r">Press</div>
                            <div class="py-2 pb-5">Writing a story about us? Need a picture or logo? Please feel free
                              to download from our selection below. For interviews us at info@atlasimprov.com.
                            </div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold ">Company Logo</div>
                            <div class="contact-link"><a :href="assetUrl(press.pdf_logo.id)">pdf</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.image_logo_small.id)">png(small)</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.image_logo_medium.id)">png(medium)</a></div>
                            <div class="contact-link pb-5"><a :href="assetUrl(press.image_logo_large.id)">png(large)</a></div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold">Company Pictures</div>
                            <div class="contact-link"><a :href="assetUrl(press.pdf_logo.id)">image 1</a></div>
                            <div class="contact-link pb-5"><a :href="assetUrl(press.pdf_logo.id)">image 2</a></div>
                          </div>
                          <div>
                            <div class="text-uppercase display-5 oswald-bold">Press Releases</div>
                            <div class="contact-link"><a :href="assetUrl(press.cut_release.id)">The Cut</a></div>
                            <div class="contact-link"><a :href="assetUrl(press.endurance_release.id)">The Endurance Improv Festival</a></div>
                          </div>
                        </div>
                    </div>
                </div>
                <picture>
                  <source srcset="@/assets/Press-mobile-bg.png" media="(max-width: 767px)" />
                  <img :src="require('@/assets/Press-bg.png')" class="img-fluid w-100" />
                </picture>
            </div>
        </div>


        <Footer />

    </div>



</template>

<script>
import axios from 'axios';
import Footer from '../components/Footer.vue';
import Nav from "../components/Nav.vue";


export default {
  name: 'Contact',
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      press: null,
    };
  },
  methods: {
    async fetchPressAssets() {
      try {
        const response = await axios.post(this.$API_GRAPHQL, {
          query: `
            query {
              press {
                pdf_logo { id }
                image_logo_large { id }
                image_logo_medium { id }
                image_logo_small { id }
                cut_release { id }
                endurance_release { id }
              }
            }
          `
        }, {
          headers: {
            Authorization: `Bearer Pm4Nd5_e46HaK2xtkPcla2PMBzbk9AQf`,
            'Content-Type': 'application/json'
          }
        });

        this.press = response.data.data.press;
      } catch (error) {
        console.error('Error fetching press assets:', error);
      }
    },
    assetUrl(id) {
      return `${this.$API_ASSETS}${id}`;
    }
  },
  created() {
    this.fetchPressAssets();
  }
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .text-overlay {
    position: static !important;
    padding: 2rem 1rem;
  }

  .press-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  .press-grid .col-span-2 {
    grid-column: span 2;
  }
}
</style>
